<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"  @checkbox="checkbox" @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE  ref="childUpdate"  @submit="submit" :updateData="updateData"></UPDATE>
  </div>
</template>

<script>
  //table封装组件
  import tablePage from '@/components/page/table.vue'
  import FORM from '@/components/page/form.vue'
  import UPDATE from '@/components/page/update.vue'
  import Qs from 'qs'
  import Url from "@/api/sys/messageRecode"
  let verifyType = {0:"短信发送",1:"邮件发送"};
  let device = {"PC":"PC","M":"M"};
  let businessType = {"36":"TREX"};
  export default {
    name: 'list',
    components: {
      tablePage,
      FORM,
      UPDATE
    },
    methods: {
      checkbox(row){
        this.deleteIds = row.map(key => key.id).join(",");
      },
      /*表格按钮点击事件*/
      bthClick (clickName, row) {
        if (clickName == "modify"){
          this.$refs.childUpdate.open(row);
        }else if (clickName == "delete") {
            this.$axios.get(URL.emailCodeDel, {
                params:{id: row.id}
            }).then((res)=>{
                if (res.code == 0) {
                    this.$refs.childTable.defaultGetData(this.queryData);
                    this.$message.success(window.$t('mis.faceConfig.deleteSuccess'))
                } else {
                    this.$message.error(res.message);
                }
            }).catch(function (error) {
                console.log(error);
            });
        }
      },
      /*查询表单按钮点击事件*/
      formclick(clickName, data){
        if("查询" == clickName){
          this.queryData = data;
          this.$refs.childTable.defaultQueryData(data);
        }else if("新增" == clickName){
          this.$refs.childUpdate.open();
        }
      },
      /*新增或跟提交数据触发事件*/
      submit(model){
        //根据是否包含id更新还是添加
        this.dataChanage(Url.emailCodeSave,model,res => {
          if (res.code == 0){
          this.$refs.childUpdate.close();
          this.$message.success("suc");
          this.$refs.childTable.defaultGetData(this.queryData);
        }else{

        }
      })
      },
      dataChanage(url,option,suc,fail){
        this.axios.post(url, Qs.stringify(option || {})).then(res => {

        if(suc && (typeof suc == 'function')) suc(res);
      }).catch(res => {
          if(fail && (typeof fail == 'function')) fail(res);
      })
      }
    },
    data () {
      return {
        deleteIds:"",
        queryData:{},
        /*新增或更新*/
        updateData:{
          cols:[
                          { title: 'id', field: 'id',hidden:true},
                          { title: '通道所属公司', field: 'businessType',type: 2,optionList:businessType},
                          { title: '页面端', field: 'device',type: 2,optionList:device},
                          { title: '发送验证码方式', field: 'verifyType',type: 2,optionList:verifyType,isNumber: true},
                      ]
        },
        /*from查询表单*/
        formData:{
          hasLable: true,
          cols:[
                          { title: '页面端', field: 'device',type: 2,optionList:device},
                          { title: '发送验证码方式', field: 'verifyType',type: 2,optionList:verifyType,isNumber: true},
                          {click:"查询"},
                          {click:"新增"}
          ]
        },
        /*table生成*/
        pageData: {
          queryUrl: Url.emailCodeList, //请求路径和参数
          selection: true,
          sequence: true,
          cols: [
                          { title: '页面端', field: 'device', render: (data, full) => {
                                  return device[data] || "";
                              }},
                          { title: '发送验证码方式', field: 'verifyType', render: (data, full) => {
                                  return verifyType[data] || "";
                              }},
                          { title: '设置时间', field: 'createDate'},
                          { title: '设置人', field: 'createUser'},
                          { title: '修改人', field: 'updateUser'},
                          { title: '修改时间', field: 'updateDate'},
                          {
                              title: "操作", btnClick: [{name: "修改", click: "modify", type: "primary", icon: "el-icon-edit"}, {name: "删除", click: "delete", type: "primary", icon: "el-icon-delete"}]
                          },
          ]
        }
      }
    }
  }
</script>
